import React from 'react'
import { Link } from 'react-router-dom'
import { Col, Container, Row } from 'reactstrap'

import cx from 'classnames'

const FolkhogskolaContent = () => {
	return (
		<React.Fragment>
			<Container fluid>
				<Row>
					<h1 className={cx('heading hd-st-1')}>LEKTIONSAKUTEN</h1>
					<h1 className={cx('heading hd-st-2')}>FOLKHÖGSKOLA</h1>
					<Col className={cx('text-body')}>
						<p className="mato_ingress">
							Välkommen till Lektionsakuten för folkhögskolor!
						</p>
						<p>
							Vi arbetar för en bättre arbetsmiljö för lärare, skolledare och deltagare. Vårt primära syfte med tjänsten är att kunna bidra med en back-up-lösning i de fall då fysiska och/eller legitimerade lärare inte finns att tillgå.
						</p>
						<p>
							Vår tjänst är inte tänkt att användas för att ersätta ordinarie undervisning eller ordinarie lärare, utan finns där som stöd vid sjukfrånvaro, VAB eller annan planerad frånvaro då fysiska lärare inte finns att tillgå.
						</p>
						<p>
							Vårt material kan också användas tillsammans med en stödpedagog i klassrummet för att säkerställa att deltagare får med sig viktiga ämneskunskaper.
						</p>
						<p>
							Tjänsten kan även användas som en stödfunktion/ett hjälpmedel direkt riktat mot elever så att fler deltagare får det stöd som de behöver för att uppnå ett komplett studieomdöme.
						</p>
						<p className={cx('font-st')}>
							Fördelen med vår tjänst är att ordinarie lärare alltid har kontroll över undervisningen!
						</p>
					</Col>
				</Row>
				<Row>
					<Link to='/vuxenutbildning'>
					<div className={cx("outer-st out-st-1")}>
						<div className={cx("inner")}>
							<p style={{fontWeight: 'bold', color: '#000000'}}>VUXENUTBILDNING</p>
						</div>
					</div>
					</Link>
					<Link to='/gymnasieskola'>
					<div className={cx("outer-st out-st-2")}>
						<div className={cx("inner")}>
							<p className={cx('font-st')}>GYMNASIESKOLA</p>
						</div>
					</div>
					</Link>
					<Link to='/grundskola'>
					<div className={cx("outer-st out-st-3")}>
						<div className={cx("inner")}>
							<p className={cx('font-st')}>GRUNDSKOLA</p>
						</div>
					</div>
					</Link>
				</Row>
		</Container>
		</React.Fragment>
	)
}



export default FolkhogskolaContent